/**
 * OnboardingStrip - First-time user guide strip below search bar
 * Auto-hides after first download or manual dismiss
 */
import { useState, useEffect } from "react";
import { ArrowRight, X } from "lucide-react";

const STORAGE_KEY = "spp_onboarding_strip_dismissed";

export function OnboardingStrip({ downloadsUsed }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed && downloadsUsed === 0) {
      setVisible(true);
    }
  }, [downloadsUsed]);

  // Auto-hide after first download
  useEffect(() => {
    if (downloadsUsed > 0 && visible) {
      setVisible(false);
      localStorage.setItem(STORAGE_KEY, "true");
    }
  }, [downloadsUsed, visible]);

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(STORAGE_KEY, "true");
  };

  if (!visible) return null;

  return (
    <div
      className="relative rounded-lg border border-blue-100 bg-blue-50/50 px-5 py-3.5 mt-2.5"
      data-testid="onboarding-strip"
    >
      <button
        onClick={dismiss}
        className="absolute top-2.5 right-2.5 text-slate-400 hover:text-slate-600 transition-colors"
        data-testid="onboarding-strip-dismiss"
      >
        <X className="h-3.5 w-3.5" />
      </button>
      <p className="text-sm font-medium text-slate-800 pr-6" data-testid="onboarding-strip-text">
        <span className="text-blue-700 font-semibold">How it works:</span>{" "}
        Search your dish <ArrowRight className="inline h-3 w-3 text-slate-400 mx-0.5" /> download free samples <ArrowRight className="inline h-3 w-3 text-slate-400 mx-0.5" /> upload to your menu
      </p>
      <p className="text-[11px] text-slate-500 mt-1">
        Pre-approved visuals for Zomato & Swiggy. No photoshoot needed.
      </p>
    </div>
  );
}
